import { createSelector } from 'reselect';
import { BlankItem, MediaTypeSelection } from 'packages/pages/designCreateModal/components/Blank/types';
import { DesignSubPages } from 'packages/pages/designCreateModal/components/Sidebar/types';
import { NewDesignState } from './types';

const getNewDesign = (state: any): NewDesignState => state.newDesign;

export const getNewDesignPage = (state: any): DesignSubPages => state.newDesign.activePage || DesignSubPages.ALL;
export const getNewDesignPageHistory = (state: any): DesignSubPages => state.newDesign.history;

export const getSelectedBlankType = (state: any): MediaTypeSelection => state.newDesign.blank.selectedType;
export const getSelectedBlankItems = createSelector(getNewDesign, (newDesign): BlankItem[] => [
    newDesign.blank[MediaTypeSelection.VIDEO] as unknown as BlankItem,
    newDesign.blank[MediaTypeSelection.IMAGE] as unknown as BlankItem,
]);

export const getBlankDesignActionProgress = createSelector(
    getNewDesign,
    (
        newDesign,
    ): {
        addingInProgress: NewDesignState['addingInProgress'];
    } => ({
        addingInProgress: newDesign.addingInProgress,
    }),
);
